import { ACCOUNT_TYPES } from "./account-type"
import { ADDRESS_DESER, Address } from "./customer"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class Entity {
  address = new Address()
  entityType: ACCOUNT_TYPES = ACCOUNT_TYPES.BUSINESS
  id = "0"
  legalName = ""
}

export const ENTITY_DESER: SchemaDeSer<Entity> = new SchemaDeSerBuilder(Entity)
  .ofNested("address", ADDRESS_DESER, Address)
  .ofString("entityType")
  .ofString("id")
  .ofString("legalName")
  .toDeSer()
